import * as constants from "./constants";

const initialState = {
  allEmails: {
    email_templates: [],
    template_macros: [],
    loading: true,
    // notificationHistoryList: [],
  },
  error: null,
};
const emailsManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.FETCH_EMAILS_TEMPLATES_LIST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case constants.FETCH_EMAILS_TEMPLATES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        allEmails: action.payload,
      };

    case constants.FETCH_EMAILS_TEMPLATES_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    case constants.SEND_EMAIL:
      return {
        ...state,
        loading: true,
        // createUserLoading: true,
      };
    case constants.SEND_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case constants.SEND_EMAIL_FAILURE:
      return {
        ...state,
        loading: false,
      };

    case constants.FETCH_EMAILS_HISTORY:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case constants.FETCH_EMAILS_HISTORY_SUCCESS:
      return {
        ...state,
        loading: false,
        emailsHistoryList: action.payload,
      };

    case constants.FETCH_EMAILS_HISTORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default emailsManagerReducer;
